/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { faSpinner, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Dienstplanuebernahme } from '../../entities';
import { useState } from 'react';
import { useDienstplanuebernahmeUebernehmen } from '../../hooks/useDienstplanuebernahme';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@e2n/ui';

export function AlleUebernehmenDialog({
  dienstplanuebernahmen,
  isLoading,
  setIsLoading,
}: {
  dienstplanuebernahmen: Dienstplanuebernahme[];
  isLoading: boolean;
  setIsLoading: (bool: boolean) => void;
}) {
  const { t } = useTranslation();
  const [uebernehmen] = useDienstplanuebernahmeUebernehmen();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger disabled={isLoading || dienstplanuebernahmen.length === 0}>
        <TooltipProvider>
          <Tooltip>
            <TooltipContent>
              {t(
                'domain.arbeitszeiten.dienstplanuebernahme.buttons.uebernehmen',
                { count: dienstplanuebernahmen.length },
              )}
            </TooltipContent>
            <TooltipTrigger>
              <Button
                disabled={isLoading || dienstplanuebernahmen.length === 0}
                className="bg-primary-blue-500 text-white size-7">
                {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                {!isLoading && <FontAwesomeIcon icon={faCheck} />}
              </Button>
            </TooltipTrigger>
          </Tooltip>
        </TooltipProvider>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t('domain.arbeitszeiten.dienstplanuebernahme.dialog.title')}
          </DialogTitle>
        </DialogHeader>
        {dienstplanuebernahmen.length < 2 && (
          <p>
            {t(
              'domain.arbeitszeiten.dienstplanuebernahme.dialog.descriptionUebernehmen_one',
              {
                count: dienstplanuebernahmen.length,
              },
            )}
          </p>
        )}
        {dienstplanuebernahmen.length > 1 && (
          <p>
            {t(
              'domain.arbeitszeiten.dienstplanuebernahme.dialog.descriptionUebernehmen_many',
              {
                count: dienstplanuebernahmen.length,
              },
            )}
          </p>
        )}
        <DialogFooter className="flex gap-4">
          <Button
            disabled={isLoading}
            onClick={() => {
              setIsLoading(true);
              uebernehmen(dienstplanuebernahmen).finally(() => {
                setIsLoading(false);
                setIsDialogOpen(false);
              });
            }}>
            {t(
              'domain.arbeitszeiten.dienstplanuebernahme.dialog.buttonUebernehmen',
            )}

            {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
